import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccessibilityQuickLinks, LazyBadge, LazyLogo, LazyTag, LazyTextLink, LazyButton, LazyButtonBack, LazyButtonBase, LazyButtonIcon, LazyButtonNavigation, LazyCheckbox, LazyDate, LazyEmail, LazyFile, LazyHidden, LazyInput, LazyNumber, LazyPassword, LazyRadio, LazyRecaptchaInfo, LazyTextarea, LazyToggle, LazyWebformMarkup, LazySelect, LazySelectScheleton, LazyTelInput, LazyTelInputScheleton, LazyAlert, LazyArrowBendRightDownLarge, LazyArrowLeft, LazyArrowRegularLeftMobile, LazyArrowRegularRightMobile, LazyArrowRegularTop, LazyAudioBook, LazyBlog, LazyBook, LazyBooks, LazyCalendar, LazyCalendarAlt, LazyCart, LazyChat, LazyCheck, LazyCombo, LazyContact, LazyDelete, LazyDocument, LazyDownload, LazyDropdown, LazyDuplicate, LazyEbook, LazyEdit, LazyEllipse, LazyFacebook, LazyFolder, LazyHide, LazyIcon, LazyInfo, LazyInstagram, LazyLargeArrow, LazyLargeClose, LazyLinkAlt, LazyLinkArrow, LazyLinkedin, LazyMap, LazyMedia, LazyMediaPlay, LazyMiniArrowDown, LazyMiniArrowDropdown, LazyMiniArrowLink, LazyMiniArrowRegular, LazyMiniArrowSliderLeft, LazyMiniArrowSliderRight, LazyMiniArrowThin, LazyMiniArrowUp, LazyMiniBullet, LazyMiniCheck, LazyMiniCheckbox, LazyMiniCloseMedium, LazyMiniCloseSmall, LazyMiniDropdown, LazyMiniMinusSmall, LazyMiniPlusSmall, LazyMiniSmall, LazyMobileMenu, LazyNotification, LazyOffers, LazyPin, LazyPricelist, LazyProduct, LazyProfile, LazySearch, LazySet, LazySetting, LazyShow, LazyShowcases, LazySocialBlog, LazySocialFacebook, LazySocialInstagram, LazySocialLinkedin, LazySocialTwitter, LazySocialXing, LazySocialYoutube, LazySpotify, LazyTextlink, LazyTwitter, LazyUpload, LazyUserWork, LazyWarning, LazyWeb, LazyYoutube, LazyBreadcrumbs, LazyLinkList, LazyPagination, LazySearchField, LazyTextSpecial, LazyAddress, LazyCompany, LazyPersonalDetails, LazyPersonalInfo, LazyPhones, LazyProfessionalInfo, LazyTags, LazyHeaderCheckout, LazyLanguageSwitcher, LazyPageLoadingIndicator, LazyFooter, LazyFooterComplianceMenu, LazyFooterMenu, LazyFooterMetaMenu, LazyFooterSocial, LazyHeader, LazyHeaderActionButton, LazyHeaderActionCart, LazyHeaderActionMobileMenuToggle, LazyHeaderActionProfile, LazyHeaderActionSearch, LazyHeaderActions, LazyMainMenu, LazyMainMenuMobile, LazyMetaMenu, LazyNavigation, LazyNavigationMobile, LazySubMenu, LazySubMenuItems, LazySubMenuMobile, LazySubMenus, LazySubMenusMobile, LazyUseAutoHide, LazyUseMainMenu, LazyUseSubmenuVisibility, LazyModalNavigationMobile, LazyModalSearch, LazyUseSearch, LazyCbzFooter, LazyCbzHero, LazyCbzLinkItem, LazyCbzSearch, LazyPracticaBlock, LazyPracticaItem, LazySectionCbzAccordion, LazySectionCbzDownloads, LazySectionCbzLinks, LazySectionCbzNewContent, LazySectionCbzNewsletter, LazyAccordion, LazyAccordionItem, LazyComment, LazyCommentForm, LazyComments, LazyDownloadItem, LazyDownloads, LazyEmailContactForm, LazyEmployeeList, LazyEmployeeSingle, LazyEmployeeTeaser, LazyEventRegistrationForm, LazyEvents, LazyGoogleMap, LazyHero, LazyHeroColor, LazyHotspotItem, LazyHotspotItemModalContent, LazyImage, LazyIntrotext, LazyLinkListLarge, LazyLinkListLargeItem, LazyLinkListLargeItemEducationalOffering, LazyLinkListLargeItemEvent, LazyPersonBase, LazyPicture, LazyProductReview, LazySearchResult, LazySection, LazySectionFilters, LazySectionSocialWall, LazySectionSpecial, LazySectionTitle, LazyShare, LazyStickyEventTeaser, LazyStoriesSlide, LazyTab, LazyTabHeader, LazyTabs, LazyTeaserSingle, LazyTeaserSlide, LazyTeaserSlider, LazyTimelineFieldItem, LazyTimelineModalContent, LazyTimelineRegularCounter, LazyTimelineVideoCounter, LazyCard, LazyCardImage, LazyCardText, LazyToccoBase, LazyToccoBaseSidebar, LazyToccoAccordion, LazyToccoButtonTaxonomy, LazyToccoContactPersonTeaser, LazyToccoContactPersons, LazyToccoContactPersonsModal, LazyToccoEventTeaser, LazyToccoModuleAddToCart, LazyToccoModuleAddToCartDetails, LazyToccoRegistrationConferenceReview, LazyToccoRegistrationModuleReview, LazyToccoRegistrationSeminarReview, LazyToccoModuleModal, LazySectionToccoAccordion, LazySectionToccoContactPersons, LazySectionToccoDates, LazySectionToccoDownloads, LazySectionToccoEmployees, LazySectionToccoEntityTeaser, LazySectionToccoRelatedSeminars, LazySectionToccoSeminarModules, LazySectionToccoSeminarModulesCategory, LazySectionToccoShare, LazyModalContactForm, LazyModalEmployee, LazyModalEmpty, LazyModalVideo, LazyOpenJobContactPerson, LazySectionMap, LazySectionOpenJobContacts, LazySectionOpenJobQuote, LazySectionTwoColumnText, LazyEmployee, LazyNodeCbzLandingPage, LazyNodeEvent, LazyNodeLandingPage, LazyNodeNews, LazyNodeOpenJob, LazyNodePage, LazyNodeProtectedPage, LazyToccoCourse, LazyToccoModule, LazyToccoSeminar, LazyToccoWebinar, LazySectionAccordion, LazySectionAnchors, LazySectionCarousel, LazySectionComments, LazySectionContact, LazySectionContactPerson, LazySectionContainerWidgetMain, LazySectionDownloads, LazySectionEducationOverview, LazySectionEventListing, LazySectionEventRegistration, LazySectionEventRelated, LazySectionEventTeasers, LazySectionFeaturedNewsPosts, LazySectionForm, LazySectionFullHtmlText, LazySectionHero, LazySectionHeroHome, LazySectionHeroNews, LazySectionHeroSearch, LazySectionHotspotGraphic, LazySectionIframe, LazySectionImage, LazySectionInfoBox, LazySectionInfoBoxes, LazySectionIntrotext, LazySectionJsScripts, LazySectionLargeLinklist, LazySectionLatestEducationOfferings, LazySectionLinklist, LazySectionListing, LazySectionMegaTeaser, LazySectionSchedule, LazySectionShare, LazySectionShopStartpageInfo, LazySectionShopTeasers, LazySectionSidebar, LazySectionSingleTeaser, LazySectionSpecificTagsNews, LazySectionStickyEventTeaser, LazySectionStories, LazySectionTable, LazySectionTeaserGrid, LazySectionTeaserSlider, LazySectionTeaserTiles, LazySectionTestimonial, LazySectionText, LazySectionTextImage, LazySectionTimeline, LazySectionVideo, LazySections, LazyEmployeesListing, LazyEventsListing, LazyEventsListingConference, LazyEventsListingInfo, LazyNewsListing, LazyPracticasListing, LazyToccoListing, LazySidebarSection, LazyAuthorSidebar, LazyCareerAdviceToccoSidebar, LazyCtaSidebar, LazyLabelValueSidebar, LazyLocationSidebar, LazyLogoSidebar, LazyTagsSidebar, LazyTextLinkSidebar, LazyTextSidebar, LazySectionAuthorSidebar, LazySectionContainerWidgetSidebar, LazySectionCtaSidebar, LazySectionLabelValueSidebar, LazySectionLogoSidebar, LazySectionTextSidebar, LazyProducts, LazyShopAddToCartButton, LazyShopAddressModal, LazyShopCartItem, LazyShopCartModal, LazyShopCartTable, LazyShopCartTotals, LazyShopCategoryPage, LazyShopLoginForm, LazyShopLoginModal, LazyShopMarketingConsentCheckbox, LazyShopNotification, LazyShopNotifications, LazyShopProductFeatures, LazyShopProductLabels, LazyShopProductPage, LazyShopProductTeaser, LazyShopProductTeaserSmall, LazyShopPromotionCode, LazyShopSideCartItem, LazyShopAccountAddressCard, LazyShopAccountAddressForm, LazyShopAccountChangePassword, LazyShopAccountOrderDetails, LazyShopAccountPersonalDetails, LazyShopFilter, LazyShopFilterArticleType, LazyShopFilterLanguage, LazyShopProductListing, LazyShopSearch, LazyShopSubcategories, LazyUseShopBreadcrumbs, LazyShopProductVariant, LazyCmsGenericBlock, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsPage, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCrossSelling, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockGalleryBuybox, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageCover, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextBubble, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeColumn, LazyCmsBlockImageThreeCover, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductHeading, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockProductThreeColumn, LazyCmsBlockSidebarFilter, LazyCmsBlockText, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockTextThreeColumn, LazyCmsBlockTextTwoColumn, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsElementBuyBox, LazyCmsElementCategoryNavigation, LazyCmsElementCrossSelling, LazyCmsElementCustomForm, LazyCmsElementForm, LazyCmsElementImage, LazyCmsElementImageGallery, LazyCmsElementImageSlider, LazyCmsElementManufacturerLogo, LazyCmsElementProductBox, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductListing, LazyCmsElementProductName, LazyCmsElementProductSlider, LazyCmsElementSidebarFilter, LazyCmsElementText, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyCmsSectionDefault, LazyCmsSectionSidebar } from '#components'
const lazyGlobalComponents = [
  ["AccessibilityQuickLinks", LazyAccessibilityQuickLinks],
["Badge", LazyBadge],
["Logo", LazyLogo],
["Tag", LazyTag],
["TextLink", LazyTextLink],
["Button", LazyButton],
["ButtonBack", LazyButtonBack],
["ButtonBase", LazyButtonBase],
["ButtonIcon", LazyButtonIcon],
["ButtonNavigation", LazyButtonNavigation],
["Checkbox", LazyCheckbox],
["Date", LazyDate],
["Email", LazyEmail],
["File", LazyFile],
["Hidden", LazyHidden],
["Input", LazyInput],
["Number", LazyNumber],
["Password", LazyPassword],
["Radio", LazyRadio],
["RecaptchaInfo", LazyRecaptchaInfo],
["Textarea", LazyTextarea],
["Toggle", LazyToggle],
["WebformMarkup", LazyWebformMarkup],
["Select", LazySelect],
["SelectScheleton", LazySelectScheleton],
["TelInput", LazyTelInput],
["TelInputScheleton", LazyTelInputScheleton],
["Alert", LazyAlert],
["ArrowBendRightDownLarge", LazyArrowBendRightDownLarge],
["ArrowLeft", LazyArrowLeft],
["ArrowRegularLeftMobile", LazyArrowRegularLeftMobile],
["ArrowRegularRightMobile", LazyArrowRegularRightMobile],
["ArrowRegularTop", LazyArrowRegularTop],
["AudioBook", LazyAudioBook],
["Blog", LazyBlog],
["Book", LazyBook],
["Books", LazyBooks],
["Calendar", LazyCalendar],
["CalendarAlt", LazyCalendarAlt],
["Cart", LazyCart],
["Chat", LazyChat],
["Check", LazyCheck],
["Combo", LazyCombo],
["Contact", LazyContact],
["Delete", LazyDelete],
["Document", LazyDocument],
["Download", LazyDownload],
["Dropdown", LazyDropdown],
["Duplicate", LazyDuplicate],
["Ebook", LazyEbook],
["Edit", LazyEdit],
["Ellipse", LazyEllipse],
["Facebook", LazyFacebook],
["Folder", LazyFolder],
["Hide", LazyHide],
["Icon", LazyIcon],
["Info", LazyInfo],
["Instagram", LazyInstagram],
["LargeArrow", LazyLargeArrow],
["LargeClose", LazyLargeClose],
["LinkAlt", LazyLinkAlt],
["LinkArrow", LazyLinkArrow],
["Linkedin", LazyLinkedin],
["Map", LazyMap],
["Media", LazyMedia],
["MediaPlay", LazyMediaPlay],
["MiniArrowDown", LazyMiniArrowDown],
["MiniArrowDropdown", LazyMiniArrowDropdown],
["MiniArrowLink", LazyMiniArrowLink],
["MiniArrowRegular", LazyMiniArrowRegular],
["MiniArrowSliderLeft", LazyMiniArrowSliderLeft],
["MiniArrowSliderRight", LazyMiniArrowSliderRight],
["MiniArrowThin", LazyMiniArrowThin],
["MiniArrowUp", LazyMiniArrowUp],
["MiniBullet", LazyMiniBullet],
["MiniCheck", LazyMiniCheck],
["MiniCheckbox", LazyMiniCheckbox],
["MiniCloseMedium", LazyMiniCloseMedium],
["MiniCloseSmall", LazyMiniCloseSmall],
["MiniDropdown", LazyMiniDropdown],
["MiniMinusSmall", LazyMiniMinusSmall],
["MiniPlusSmall", LazyMiniPlusSmall],
["MiniSmall", LazyMiniSmall],
["MobileMenu", LazyMobileMenu],
["Notification", LazyNotification],
["Offers", LazyOffers],
["Pin", LazyPin],
["Pricelist", LazyPricelist],
["Product", LazyProduct],
["Profile", LazyProfile],
["Search", LazySearch],
["Set", LazySet],
["Setting", LazySetting],
["Show", LazyShow],
["Showcases", LazyShowcases],
["SocialBlog", LazySocialBlog],
["SocialFacebook", LazySocialFacebook],
["SocialInstagram", LazySocialInstagram],
["SocialLinkedin", LazySocialLinkedin],
["SocialTwitter", LazySocialTwitter],
["SocialXing", LazySocialXing],
["SocialYoutube", LazySocialYoutube],
["Spotify", LazySpotify],
["Textlink", LazyTextlink],
["Twitter", LazyTwitter],
["Upload", LazyUpload],
["UserWork", LazyUserWork],
["Warning", LazyWarning],
["Web", LazyWeb],
["Youtube", LazyYoutube],
["Breadcrumbs", LazyBreadcrumbs],
["LinkList", LazyLinkList],
["Pagination", LazyPagination],
["SearchField", LazySearchField],
["TextSpecial", LazyTextSpecial],
["Address", LazyAddress],
["Company", LazyCompany],
["PersonalDetails", LazyPersonalDetails],
["PersonalInfo", LazyPersonalInfo],
["Phones", LazyPhones],
["ProfessionalInfo", LazyProfessionalInfo],
["Tags", LazyTags],
["HeaderCheckout", LazyHeaderCheckout],
["LanguageSwitcher", LazyLanguageSwitcher],
["PageLoadingIndicator", LazyPageLoadingIndicator],
["Footer", LazyFooter],
["FooterComplianceMenu", LazyFooterComplianceMenu],
["FooterMenu", LazyFooterMenu],
["FooterMetaMenu", LazyFooterMetaMenu],
["FooterSocial", LazyFooterSocial],
["Header", LazyHeader],
["HeaderActionButton", LazyHeaderActionButton],
["HeaderActionCart", LazyHeaderActionCart],
["HeaderActionMobileMenuToggle", LazyHeaderActionMobileMenuToggle],
["HeaderActionProfile", LazyHeaderActionProfile],
["HeaderActionSearch", LazyHeaderActionSearch],
["HeaderActions", LazyHeaderActions],
["MainMenu", LazyMainMenu],
["MainMenuMobile", LazyMainMenuMobile],
["MetaMenu", LazyMetaMenu],
["Navigation", LazyNavigation],
["NavigationMobile", LazyNavigationMobile],
["SubMenu", LazySubMenu],
["SubMenuItems", LazySubMenuItems],
["SubMenuMobile", LazySubMenuMobile],
["SubMenus", LazySubMenus],
["SubMenusMobile", LazySubMenusMobile],
["UseAutoHide", LazyUseAutoHide],
["UseMainMenu", LazyUseMainMenu],
["UseSubmenuVisibility", LazyUseSubmenuVisibility],
["ModalNavigationMobile", LazyModalNavigationMobile],
["ModalSearch", LazyModalSearch],
["UseSearch", LazyUseSearch],
["CbzFooter", LazyCbzFooter],
["CbzHero", LazyCbzHero],
["CbzLinkItem", LazyCbzLinkItem],
["CbzSearch", LazyCbzSearch],
["PracticaBlock", LazyPracticaBlock],
["PracticaItem", LazyPracticaItem],
["SectionCbzAccordion", LazySectionCbzAccordion],
["SectionCbzDownloads", LazySectionCbzDownloads],
["SectionCbzLinks", LazySectionCbzLinks],
["SectionCbzNewContent", LazySectionCbzNewContent],
["SectionCbzNewsletter", LazySectionCbzNewsletter],
["Accordion", LazyAccordion],
["AccordionItem", LazyAccordionItem],
["Comment", LazyComment],
["CommentForm", LazyCommentForm],
["Comments", LazyComments],
["DownloadItem", LazyDownloadItem],
["Downloads", LazyDownloads],
["EmailContactForm", LazyEmailContactForm],
["EmployeeList", LazyEmployeeList],
["EmployeeSingle", LazyEmployeeSingle],
["EmployeeTeaser", LazyEmployeeTeaser],
["EventRegistrationForm", LazyEventRegistrationForm],
["Events", LazyEvents],
["GoogleMap", LazyGoogleMap],
["Hero", LazyHero],
["HeroColor", LazyHeroColor],
["HotspotItem", LazyHotspotItem],
["HotspotItemModalContent", LazyHotspotItemModalContent],
["Image", LazyImage],
["Introtext", LazyIntrotext],
["LinkListLarge", LazyLinkListLarge],
["LinkListLargeItem", LazyLinkListLargeItem],
["LinkListLargeItemEducationalOffering", LazyLinkListLargeItemEducationalOffering],
["LinkListLargeItemEvent", LazyLinkListLargeItemEvent],
["PersonBase", LazyPersonBase],
["Picture", LazyPicture],
["ProductReview", LazyProductReview],
["SearchResult", LazySearchResult],
["Section", LazySection],
["SectionFilters", LazySectionFilters],
["SectionSocialWall", LazySectionSocialWall],
["SectionSpecial", LazySectionSpecial],
["SectionTitle", LazySectionTitle],
["Share", LazyShare],
["StickyEventTeaser", LazyStickyEventTeaser],
["StoriesSlide", LazyStoriesSlide],
["Tab", LazyTab],
["TabHeader", LazyTabHeader],
["Tabs", LazyTabs],
["TeaserSingle", LazyTeaserSingle],
["TeaserSlide", LazyTeaserSlide],
["TeaserSlider", LazyTeaserSlider],
["TimelineFieldItem", LazyTimelineFieldItem],
["TimelineModalContent", LazyTimelineModalContent],
["TimelineRegularCounter", LazyTimelineRegularCounter],
["TimelineVideoCounter", LazyTimelineVideoCounter],
["Card", LazyCard],
["CardImage", LazyCardImage],
["CardText", LazyCardText],
["ToccoBase", LazyToccoBase],
["ToccoBaseSidebar", LazyToccoBaseSidebar],
["ToccoAccordion", LazyToccoAccordion],
["ToccoButtonTaxonomy", LazyToccoButtonTaxonomy],
["ToccoContactPersonTeaser", LazyToccoContactPersonTeaser],
["ToccoContactPersons", LazyToccoContactPersons],
["ToccoContactPersonsModal", LazyToccoContactPersonsModal],
["ToccoEventTeaser", LazyToccoEventTeaser],
["ToccoModuleAddToCart", LazyToccoModuleAddToCart],
["ToccoModuleAddToCartDetails", LazyToccoModuleAddToCartDetails],
["ToccoRegistrationConferenceReview", LazyToccoRegistrationConferenceReview],
["ToccoRegistrationModuleReview", LazyToccoRegistrationModuleReview],
["ToccoRegistrationSeminarReview", LazyToccoRegistrationSeminarReview],
["ToccoModuleModal", LazyToccoModuleModal],
["SectionToccoAccordion", LazySectionToccoAccordion],
["SectionToccoContactPersons", LazySectionToccoContactPersons],
["SectionToccoDates", LazySectionToccoDates],
["SectionToccoDownloads", LazySectionToccoDownloads],
["SectionToccoEmployees", LazySectionToccoEmployees],
["SectionToccoEntityTeaser", LazySectionToccoEntityTeaser],
["SectionToccoRelatedSeminars", LazySectionToccoRelatedSeminars],
["SectionToccoSeminarModules", LazySectionToccoSeminarModules],
["SectionToccoSeminarModulesCategory", LazySectionToccoSeminarModulesCategory],
["SectionToccoShare", LazySectionToccoShare],
["ModalContactForm", LazyModalContactForm],
["ModalEmployee", LazyModalEmployee],
["ModalEmpty", LazyModalEmpty],
["ModalVideo", LazyModalVideo],
["OpenJobContactPerson", LazyOpenJobContactPerson],
["SectionMap", LazySectionMap],
["SectionOpenJobContacts", LazySectionOpenJobContacts],
["SectionOpenJobQuote", LazySectionOpenJobQuote],
["SectionTwoColumnText", LazySectionTwoColumnText],
["Employee", LazyEmployee],
["NodeCbzLandingPage", LazyNodeCbzLandingPage],
["NodeEvent", LazyNodeEvent],
["NodeLandingPage", LazyNodeLandingPage],
["NodeNews", LazyNodeNews],
["NodeOpenJob", LazyNodeOpenJob],
["NodePage", LazyNodePage],
["NodeProtectedPage", LazyNodeProtectedPage],
["ToccoCourse", LazyToccoCourse],
["ToccoModule", LazyToccoModule],
["ToccoSeminar", LazyToccoSeminar],
["ToccoWebinar", LazyToccoWebinar],
["SectionAccordion", LazySectionAccordion],
["SectionAnchors", LazySectionAnchors],
["SectionCarousel", LazySectionCarousel],
["SectionComments", LazySectionComments],
["SectionContact", LazySectionContact],
["SectionContactPerson", LazySectionContactPerson],
["SectionContainerWidgetMain", LazySectionContainerWidgetMain],
["SectionDownloads", LazySectionDownloads],
["SectionEducationOverview", LazySectionEducationOverview],
["SectionEventListing", LazySectionEventListing],
["SectionEventRegistration", LazySectionEventRegistration],
["SectionEventRelated", LazySectionEventRelated],
["SectionEventTeasers", LazySectionEventTeasers],
["SectionFeaturedNewsPosts", LazySectionFeaturedNewsPosts],
["SectionForm", LazySectionForm],
["SectionFullHtmlText", LazySectionFullHtmlText],
["SectionHero", LazySectionHero],
["SectionHeroHome", LazySectionHeroHome],
["SectionHeroNews", LazySectionHeroNews],
["SectionHeroSearch", LazySectionHeroSearch],
["SectionHotspotGraphic", LazySectionHotspotGraphic],
["SectionIframe", LazySectionIframe],
["SectionImage", LazySectionImage],
["SectionInfoBox", LazySectionInfoBox],
["SectionInfoBoxes", LazySectionInfoBoxes],
["SectionIntrotext", LazySectionIntrotext],
["SectionJsScripts", LazySectionJsScripts],
["SectionLargeLinklist", LazySectionLargeLinklist],
["SectionLatestEducationOfferings", LazySectionLatestEducationOfferings],
["SectionLinklist", LazySectionLinklist],
["SectionListing", LazySectionListing],
["SectionMegaTeaser", LazySectionMegaTeaser],
["SectionSchedule", LazySectionSchedule],
["SectionShare", LazySectionShare],
["SectionShopStartpageInfo", LazySectionShopStartpageInfo],
["SectionShopTeasers", LazySectionShopTeasers],
["SectionSidebar", LazySectionSidebar],
["SectionSingleTeaser", LazySectionSingleTeaser],
["SectionSpecificTagsNews", LazySectionSpecificTagsNews],
["SectionStickyEventTeaser", LazySectionStickyEventTeaser],
["SectionStories", LazySectionStories],
["SectionTable", LazySectionTable],
["SectionTeaserGrid", LazySectionTeaserGrid],
["SectionTeaserSlider", LazySectionTeaserSlider],
["SectionTeaserTiles", LazySectionTeaserTiles],
["SectionTestimonial", LazySectionTestimonial],
["SectionText", LazySectionText],
["SectionTextImage", LazySectionTextImage],
["SectionTimeline", LazySectionTimeline],
["SectionVideo", LazySectionVideo],
["Sections", LazySections],
["EmployeesListing", LazyEmployeesListing],
["EventsListing", LazyEventsListing],
["EventsListingConference", LazyEventsListingConference],
["EventsListingInfo", LazyEventsListingInfo],
["NewsListing", LazyNewsListing],
["PracticasListing", LazyPracticasListing],
["ToccoListing", LazyToccoListing],
["SidebarSection", LazySidebarSection],
["AuthorSidebar", LazyAuthorSidebar],
["CareerAdviceToccoSidebar", LazyCareerAdviceToccoSidebar],
["CtaSidebar", LazyCtaSidebar],
["LabelValueSidebar", LazyLabelValueSidebar],
["LocationSidebar", LazyLocationSidebar],
["LogoSidebar", LazyLogoSidebar],
["TagsSidebar", LazyTagsSidebar],
["TextLinkSidebar", LazyTextLinkSidebar],
["TextSidebar", LazyTextSidebar],
["SectionAuthorSidebar", LazySectionAuthorSidebar],
["SectionContainerWidgetSidebar", LazySectionContainerWidgetSidebar],
["SectionCtaSidebar", LazySectionCtaSidebar],
["SectionLabelValueSidebar", LazySectionLabelValueSidebar],
["SectionLogoSidebar", LazySectionLogoSidebar],
["SectionTextSidebar", LazySectionTextSidebar],
["Products", LazyProducts],
["ShopAddToCartButton", LazyShopAddToCartButton],
["ShopAddressModal", LazyShopAddressModal],
["ShopCartItem", LazyShopCartItem],
["ShopCartModal", LazyShopCartModal],
["ShopCartTable", LazyShopCartTable],
["ShopCartTotals", LazyShopCartTotals],
["ShopCategoryPage", LazyShopCategoryPage],
["ShopLoginForm", LazyShopLoginForm],
["ShopLoginModal", LazyShopLoginModal],
["ShopMarketingConsentCheckbox", LazyShopMarketingConsentCheckbox],
["ShopNotification", LazyShopNotification],
["ShopNotifications", LazyShopNotifications],
["ShopProductFeatures", LazyShopProductFeatures],
["ShopProductLabels", LazyShopProductLabels],
["ShopProductPage", LazyShopProductPage],
["ShopProductTeaser", LazyShopProductTeaser],
["ShopProductTeaserSmall", LazyShopProductTeaserSmall],
["ShopPromotionCode", LazyShopPromotionCode],
["ShopSideCartItem", LazyShopSideCartItem],
["ShopAccountAddressCard", LazyShopAccountAddressCard],
["ShopAccountAddressForm", LazyShopAccountAddressForm],
["ShopAccountChangePassword", LazyShopAccountChangePassword],
["ShopAccountOrderDetails", LazyShopAccountOrderDetails],
["ShopAccountPersonalDetails", LazyShopAccountPersonalDetails],
["ShopFilter", LazyShopFilter],
["ShopFilterArticleType", LazyShopFilterArticleType],
["ShopFilterLanguage", LazyShopFilterLanguage],
["ShopProductListing", LazyShopProductListing],
["ShopSearch", LazyShopSearch],
["ShopSubcategories", LazyShopSubcategories],
["UseShopBreadcrumbs", LazyUseShopBreadcrumbs],
["ShopProductVariant", LazyShopProductVariant],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsPage", LazyCmsPage],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementForm", LazyCmsElementForm],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsElementText", LazyCmsElementText],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["CmsSectionDefault", LazyCmsSectionDefault],
["CmsSectionSidebar", LazyCmsSectionSidebar],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
